import currency from './../assets/currency';

export const UGX = value => currency(value, { seperator: ',', decimal: '.', symbol: 'UGX ', precision: 0 });
const cur = (value, decimals = 2) => currency(value, { seperator: ',', decimal: '.', symbol: '', precision: decimals });
export default cur;